export default __webpack_public_path__ + "static/media/Group 1285Yono.e807376a.png";